module.exports = {"654203101":"四道河子镇","654203102":"老沙湾镇","654203103":"乌兰乌苏镇","654203104":"安集海镇","654203105":"东湾镇","654203106":"西戈壁镇","654203107":"柳毛湾镇","654203108":"金沟河镇","654203109":"三道河子镇","654203200":"商户地乡","654203201":"大泉乡","654203202":"博尔通古乡","654203402":"良种场","654203500":"兵团北泉镇分部","654203503":"兵团一二一团","654203506":"兵团一三三团","654203507":"兵团一三四团","654203509":"兵团一四一团","654203510":"兵团一四二团","654203511":"兵团一四三团","654203512":"兵团一四四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/654203.json
// module id = 3280
// module chunks = 0